import React, { useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import CafTabContent from "./cafTabContent";
import {
  Box,
  Grid,
  Tab,
  Tabs,
  Typography,
  Button,
  AppBar,
  Toolbar,
} from "@material-ui/core";
import DataClient from "../../../../../../Service/general_data_service";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import CopyToClipboard from "../../../../../../Components/copy_to_clipboard";
import EditCaf from "./editCaf";

const useStyles = makeStyles((theme) => ({
  tabRoot: {
    "& .MuiTabs-flexContainer": {
      justifyContent: "flex-start",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
    },
  },
  tabs: {
    color: "#1e1e1e",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#ddd",
    backgroundColor: "rgba(7,127,131,.75)",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    marginRight: 10,
    // fontSize: "18px",
    minWidth: 130,
    textTransform: "none",
    "&:hover,&.Mui-selected": {
      color: "#fff",
      backgroundColor: "rgba(7,127,131,1)",
      opacity: 1,
    },
  },
  overviewContainer: {
    position: "sticky",
    top: 64,
    paddingTop: 40,
    background: "#fff",
    zIndex: 1,
  },
  appBar: {
    backgroundColor: "#fff",
    color: "#232323",
    boxShadow: "0px 3px 6px #232323",
    marginBottom: "2rem",
  },
}));

export default function Crf(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [pageData, setPageData] = React.useState({});
  const [ctcUrl, setCtcUrl] = React.useState("");
  const [action, setAction] = React.useState("view");
  const [loading, setLoading] = React.useState(false);
  function TabPanel(props) {
    const { children, value, index, option, ...other } = props;
    return (
      <Box
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <CafTabContent
            pageData={option.coaching_agreement_form_fields}
            subHeading={option.sub_heading}
            additionalSection={option.additional_sections}
          />
        )}
      </Box>
    );
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    getData();
  }, [action]);

  const getData = (params) => {
    DataClient.getData(
      `/coaching_agreement_form_answers/view_caf?assignment_id=${props.location?.state?.currentAssignment?.id}`
    ).then((res) => {
      if (res.coaching_agreement_form) {
        pageData.length = 0;
        setPageData({ ...pageData, ...res.coaching_agreement_form });

        setCtcUrl(res.coaching_agreement_form.slug);
      } else {
        setLoading(false);
      }
    });
  };
  const copyUrl = useSelector((state) => state.commonReducer)?.accessPermission
    ?.assignmentDetail.caf.copyURL;

  const displayEditIcon = useSelector((state) => state.commonReducer)?.accessPermission
    ?.assignmentDetail.caf.displayEditIcon;



  return (
    <>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid
          item
          xs={11}
          style={{ textAlign: "center" }}
          direction="row"
          justify="center"
          alignItems="center"
          className={classes.overviewContainer}
        >
          <AppBar position="static" className={classes.appBar} elevation={0}>
            <Toolbar>
              <Grid
                container
                direction="row"
                justify="left"
                alignItems="left"
                xs={12}
              >
                <Grid item xs={6}>
                  <Typography variant="h1" style={{ color: "#4A4A4A" }}>
                    <Box textAlign="left" fontWeight="fontWeightBold">
                      Coaching agreement form
                    </Box>
                    {pageData?.submitted_at && (
                      <Box textAlign="left" style={{ fontSize: "15px" }}>
                        {" "}
                        Received on{" "}
                        {moment(pageData.submitted_at).format("DD/MM/YYYY")}
                      </Box>
                    )}
                  </Typography>
                </Grid>
                {displayEditIcon && <Grid item xs={6} style={{ alignSelf: "center" }}>
                  <Box textAlign="right">
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() =>
                        setAction(action === "view" ? "edit" : "view")

                      } style={{ textTransform: "none" }}
                    >
                      {action === "view" ? "Edit" : "View"}
                    </Button>
                  </Box>
                </Grid>}
              </Grid>
            </Toolbar>
          </AppBar>
        </Grid>
        {copyUrl && ctcUrl && (
          <Grid item xs={11}>
            <Box mb={2}>
              <CopyToClipboard
                text={ctcUrl}
                formName={"coaching_agreement_form"}
                fontSize="16px"
              />
            </Box>
          </Grid>
        )}

        {action === "view" && (
          <>
            <Grid style={{ marginTop: "40px" }} item xs={11}>
              {pageData?.coaching_agreement_form_sections?.length > 0 && (
                <Box mb={5}>
                  <Tabs
                    value={value}
                    variant="scrollable"
                    scrollButtons="auto"
                    onChange={handleChange}
                    classes={{ root: classes.tabRoot }}
                  >
                    {pageData?.coaching_agreement_form_sections.map(
                      (option) => (
                        <Tab

                          classes={{ root: classes.tabs }}
                          label={option.section_name}
                        />
                      )
                    )}
                  </Tabs>
                  {pageData?.coaching_agreement_form_sections.map(
                    (option, index) => (
                      <TabPanel value={value} option={option} index={index}>
                        {option}
                      </TabPanel>
                    )
                  )}
                </Box>
              )}
            </Grid>
          </>
        )}
        {action === "edit" && <EditCaf {...props} />}
      </Grid>
    </>
  );
}
